import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Css/Home.css";
import Tickets from "./Tickets";
import Laws from "./Laws";
import Reports from "./Reports";

const Home = () => {
  const [show, setShow] = useState(false);
  const [activeButton, setActiveButton] = useState("Tickets");
  const [percentage, setPercentage] = useState(0);
  const [fillColor, setFillColor] = useState("#CD1041");

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const handleClick = (buttonName) =>
    setActiveButton(activeButton === buttonName ? null : buttonName);

  useEffect(() => {
    let step = 0;
    const interval = setInterval(() => {
      if (step <= 100) {
        setPercentage(step);
        setFillColor("#CD1041");
      } else if (step <= 200) {
        setPercentage(200 - step);
        setFillColor("#CD1041");
      } else if (step <= 300) {
        setPercentage(50);
        setFillColor("#0000FF");
      } else {
        clearInterval(interval);
      }
      step += 1;
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const renderButton = (buttonName) => {
    const isActive = activeButton === buttonName;
    return (
      <div key={buttonName} className="d-flex align-items-center">
        <button
          className={`btn btn-lg ${
            isActive ? "btn-danger" : "btn-outline-danger"
          } me-2`}
          onClick={() => handleClick(buttonName)}
        >
          {buttonName}
        </button>
        {isActive && (
          <img
            style={{
              height: "40px",
              width: "40px",
              position: "absolute",
              left: "180px",
            }}
            src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/Polygon.svg"
            alt="Arrow"
            className="ms-2"
          />
        )}
      </div>
    );
  };

  const renderContent = () => {
    switch (activeButton) {
      case "TICKETS":
        return <Tickets />;
      case "LAWS":
        return <Laws />;
      case "REPORTS":
        return <Reports />;
      default:
        return <Tickets />;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row h-100">
        <div className="col-2 bg-light d-flex flex-column align-items-center py-3 logo-container">
          <img
            src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/png/POMS.png"
            alt="Logo"
          />
          <h4 className="text-muted">POMS</h4>
          {renderButton("TICKETS")}
          {renderButton("LAWS")}
          {renderButton("REPORTS")}
        </div>
        <div className="col-8 d-flex flex-column align-items-center justify-content-center">
          <div className="row w-100">
            <div className="col-md-6 col-sm-6 center">
              <div
                className="semi-donut margin"
                style={{
                  "--percentage": percentage,
                  "--fill": fillColor,
                  animation: "fill-animation 6s linear forwards",
                }}
              >
                <div className="text-center">
                  <p className="mb-0 fs-6" style={{ position: "inherit" }}>
                    -124
                  </p>
                  <p className="mb-0 fs-6">
                    <span className="count">{percentage}</span>/100
                  </p>
                  <p className="mb-0 fs-7">PON</p>
                </div>
                <div className="inner-circle"></div>
              </div>
            </div>
            <div className="col-md-6 text-center">
              <div className="d-flex flex-column align-items-center">
                <div className="ticket-value my-3">
                  <h3 className="pink fw-semibold">
                    <span className="count">276</span>
                  </h3>
                </div>
                <svg width="20%" height="5" top="20">
                  <line
                    x1="0"
                    y1="0"
                    x2="100%"
                    y2="0"
                    stroke="#CD1041"
                    strokeWidth="4"
                  />
                </svg>
                <p
                  className="ticket-text dark-blue mb-0 fw-semibold fs-14"
                  style={{ fontSize: "0.7rem", width: "-1px" }}
                >
                  Warning
                </p>
              </div>
            </div>
          </div>
          <div className="card-body">{renderContent()}</div>
        </div>
        <div className="col-2 bg-light d-flex flex-column justify-content-between py-3">
          <div className="vertical-section">
            <div className="d-flex align-items-center mb-3">
              <img
                src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/user-regular-pink.svg"
                alt="User Icon"
                className="me-2"
              />
              <span>NishMobilestyx</span>
              <img
                src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/edit_icon.svg"
                alt="Edit Icon"
                className="ms-2"
              />
            </div>
            <div className="mb-3">
              <span>Login:- Date and Time</span>
            </div>
          </div>
          <svg width="100%" height="1">
            <line
              x1="0"
              y1="0"
              x2="100%"
              y2="0"
              stroke="orange"
              strokeWidth="1"
            />
          </svg>
          <div className="vertical-section">
            <div className="d-flex mb-3">
              <img
                src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/id-card-clip-solid.svg"
                alt="ID Card Icon"
                className="me-2"
              />
              <span>POLICE OFFICER</span>
            </div>
            <div className="d-flex mb-3">
              <img
                src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/location-dot-solid.svg"
                alt="Location Icon"
                className="me-2"
              />
              <span>PETERBOROUGH</span>
            </div>
            <div className="d-flex mb-3">
              <img
                src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/user-group-solid.svg"
                alt="User Group Icon"
                className="me-2"
              />
              <span>PLATOON A</span>
            </div>
            <svg width="100%" height="1">
              <line
                x1="0"
                y1="0"
                x2="100%"
                y2="0"
                stroke="orange"
                strokeWidth="1"
              />
            </svg>

            {/* <hr className="text-orange mb-3" /> */}
            {/* <div className="d-flex mb-3">
                            <img
                                src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/gauge-high-solid.svg"
                                alt="Speeding Chart Icon"
                                className="me-2"
                            />
                            <span>SPEEDING CHART</span>
                        </div> */}
            <div className="d-flex mb-3">
              <a
                href="https://pomsuat.mobilestyx.ca/police_app_peterborough/speeding_chart"
                className="d-flex align-items-center text-decoration-none  text-black"
              >
                <img
                  src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/gauge-high-solid.svg"
                  alt="Speeding Chart Icon"
                  className="me-2"
                />
                <span>SPEEDING CHART</span>
              </a>
            </div>

            <div className="d-flex mb-3">
              <a
                href="https://pomsuat.mobilestyx.ca/police_app_peterborough/help"
                className="d-flex align-items-center text-decoration-none  text-black"
              >
                <img
                  src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/circle-question-solid.svg"
                  alt="FAQs Icon"
                  className="me-2"
                />
                <span>FAQs</span>
              </a>
            </div>

            {/* <div className="d-flex mb-3">
    <a href="javascript:void(0)" className="d-flex align-items-center text-decoration-none  text-black">
        <img
            src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/headset-solid.svg"
            alt="FAQs Icon"
            className="me-2"
        />
        <span>SUPPORT</span>
    </a>
</div> */}

            <>
              <div className="d-flex mb-3">
                <a
                  href="javascript:void(0)"
                  onClick={handleShow}
                  className="d-flex align-items-center text-decoration-none  text-black"
                >
                  {/* <li className="d-flex align-items-center"> */}
                  <div className="list-img center">
                    <img
                      src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/headset-solid.svg"
                      alt="FAQs Icon"
                      className="me-2"
                    />
                  </div>
                  <span>SUPPORT</span>
                  {/* </li> */}
                </a>
              </div>
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Support Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {/* Add your support information content here */}
                  <p>Support details...</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </>

            <svg width="100%" height="1">
              <line
                x1="0"
                y1="0"
                x2="100%"
                y2="0"
                stroke="orange"
                strokeWidth="1"
              />
            </svg>
            {/* <hr className="text-orange mb-3" /> */}
            <div className="logout row align-items-center ps-3">
              <div className="col-2 col-md-2 col-sm-3 px-0">
                <img
                  className="userImg"
                  src="https://pomsuat.mobilestyx.ca/police_app_peterborough/frontend_assets/images/svg/logout-svgrepo-com-pink.svg"
                  alt="Logout"
                />
              </div>
              <div className="col-9 col-md-8 col-sm-7 user-detail d-flex flex-column pe-0">
                <a
                  className="fw-bolder fs-14"
                  href="https://pomsuat.mobilestyx.ca/police_app_peterborough/home/logout"
                >
                  LOGOUT
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
